module.exports = __webpack_public_path__ + "static/media/bursts_20.fae0a1cc.svg";